import type { EnvironmentKey } from '@web-config-app/core';

/** Bulk actions that exist once per promotion target, so their ids carry the environment. */
export const BULK_PROMOTE_ALL_ACTION = 'bulk-promote-all-entities';
export const BULK_PROMOTE_SELECTED_ACTION = 'bulk-promote-selected-entities';

/** Safe because neither an action id nor an EnvironmentKey contains a colon. */
const TARGET_SEPARATOR = ':';

/**
 * The id a per-target action is registered under, e.g. `bulk-promote-all-entities:test2`.
 *
 * Ids must stay unique now one action exists per environment, and encoding the target lets a
 * consumer pick out a whole family without knowing which environments a tenant has. Display
 * data travels on the menu item's `target` field -- this is identity, not content.
 */
export const bulkActionIdForTarget = (
  baseId: string,
  target: { environmentKey: EnvironmentKey },
) => `${baseId}${TARGET_SEPARATOR}${target.environmentKey}`;

/**
 * Matches on the separator rather than a bare `startsWith`, so a base id that prefixes another
 * (`bulk-promote-all-entities` vs `bulk-promote-all-entities-draft`) can't swallow its actions.
 */
export const isBulkActionForBaseId = (actionId: string, baseId: string) =>
  actionId.startsWith(`${baseId}${TARGET_SEPARATOR}`);
